import React, { Component } from "react";
import { bool, shape } from "prop-types";

import MetrocorpHoldingList from "pages/metrocorp/_components/MetrocorpHoldingList";
import MetrocorpFutureValuesList from "pages/metrocorp/_components/MetrocorpFutureValuesList";
import MetrocorpMovementsListGroup from "pages/metrocorp/_components/MetrocorpMovementsListGroup";
import MetrocorpMovementsList from "pages/metrocorp/_components/MetrocorpMovementsList";
import { isIOS } from "react-device-detect";
import * as configUtils from "util/config";

class MetrocorpList extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        optionSelected: bool.isRequired,
        currentDate: shape({}).isRequired,
    };

    render() {
        const { optionSelected } = this.props;

        switch (optionSelected) {
            case "holdings":
                return (
                    <div className={`metrocorp__list ${isIOS && "mx-3"}`}>
                        <MetrocorpHoldingList {...this.props} />
                    </div>
                );
            case "futureValues":
                return (
                    <div className={`metrocorp__list ${isIOS && "mx-3"}`}>
                        <MetrocorpFutureValuesList {...this.props} />
                    </div>
                );
            case "movements":
                return (
                    <div className={`metrocorp__list ${isIOS && "mx-3"}`}>
                        {configUtils.getBoolean("frontend.show.metrocorp.Adjustments.dailyMov.functionalities") ? (
                            <MetrocorpMovementsListGroup {...this.props} />
                        ) : (
                            <MetrocorpMovementsList {...this.props} />
                        )}
                    </div>
                );
            default:
                return null;
        }
    }
}

export default MetrocorpList;
